var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"social-assitance",staticStyle:{"padding":"10px"}},[_c('left-menu',{attrs:{"width":'220px'}}),_c('div',{staticClass:"contentBox",style:({height: _vm.clientHeight})},[_c('keep-alive',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }